import type { WithdrawPutRequest, WithdrawPutResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class UpdateWithdrawUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(body: WithdrawPutRequest): Promise<WithdrawPutResponse> {
    if (!body || typeof body !== 'object') {
      throw new Error('body is required');
    }
    return this.repository.updateWithdraw(body);
  }
}


